/*eslint-disable */
import {
  mapGetters
} from 'vuex';
const $ = window.jQuery = require('jquery');
import axios from 'axios';
import toast from '../../services/toast';
import countries from '../../services/country.json'
import videoSocketRef from "../../videoNotificationSocket";
import {
  bus
} from '../../main';
import root from '../../_helpers/roots';
let totalCountURL = root.memberFiltersTotalCountUrl.link;
let memberFiteredUrl = root.allUserListsUrl.link;
export default {
  name: 'member-all-user-list',
  components: {},
  props: [],
  data () {
    return {
      memberAllUser:{},
      memberAllUserResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      chatRequestDetails:'',
      checkDataTaskModal:false,
      userDetails:'',
      message:'',
      nextSteper:'',
      nextPageUrl:'',
      countryList:[],
      notConnectedUserDetails:'',
      notConnectedUserPopup:false,
      connectedUserDetailsPopup:false,
      connectedUserDetails:'',
      callConfirmationPopup:false,
      callConfirmationUserDetails:'',
      calling_text:'Yes, Call',
      is_superuser:Boolean,
      totalCountOfFilters:{},
      disabledFilters:'',
      mFilterLoading:false
    }
  },
  computed: {
  ...mapGetters([
    'memberAllUsersGetters',
    'acUserDetailsStateGetters'
  ]),
  getmemberAllUserDetailsFun(){
   this.memberAllUser = this.$store.getters.memberAllUsersGetters.data
   return
  },
  SetIntialStatus() {
    if (this.memberAllUser != undefined) {
      this.nextSteper = this.memberAllUser.next
      this.nextPageUrl = this.memberAllUser.next
      this.memberAllUserResults = this.memberAllUser.results
    }
    return
  },
  getUserDetailsAgainFun() {
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
  },
  SetIntialSuperUserStatus(){
    if (this.userDetails != undefined) {
      this.is_superuser = this.userDetails.is_superuser
    }
    return
  }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getmemberAllUserDetailsFun
    this.SetIntialStatus
    this.getUserDetailsAgainFun
    bus.$on('userUpdateStatus', (data) => {
      let user = this.memberAllUserResults.find(item => item.id == data.userID);
      if(user) {
        user.is_online = data.is_online;
      }
    });
    this.SetIntialSuperUserStatus
    this.getTotalCountFilterFun()
  },
  methods: {
    async getTotalCountFilterFun(){
     await axios.get(totalCountURL).then((response) => {
       this.totalCountOfFilters = response.data.data
    });
    },
    async filteredMemberList(param, memberCount){
      if(memberCount > 0){
      if(this.disabledFilters == '' || this.disabledFilters != param){
        this.mFilterLoading = true
        await axios.get(memberFiteredUrl + '?filter_type=' + param).then((response) => {
          this.memberAllUser = response.data.data
          this.memberAllUserResults = response.data.data.results
          this.nextSteper =  response.data.data.next
          this.nextPageUrl =  response.data.data.next
          this.mFilterLoading = false
          $('.total_count_box').removeClass('active')
          $('#filtered' + param).addClass('active')
          this.disabledFilters = param
        }).catch((err) => {
           this.mFilterLoading = false
        })
      }else{
        this.mFilterLoading = true
        await axios.get(memberFiteredUrl).then((response) => {
          this.memberAllUser = response.data.data
          this.memberAllUserResults = response.data.data.results
          this.nextSteper =  response.data.data.next
          this.nextPageUrl =  response.data.data.next
          this.mFilterLoading = false
          $('.total_count_box').removeClass('active')
          this.disabledFilters = ''
        }).catch((err) => {
           this.mFilterLoading = false
        })
      }}
    },
    notConnectedUserFun(userItems){
      this.notConnectedUserDetails = userItems
      this.notConnectedUserPopup =  true
      $('body').addClass('notConnectedUserBody')
    },
    notConnectedUserPopupClosedFun(){
      this.notConnectedUserDetails = ''
      this.notConnectedUserPopup =  false
      $('body').removeClass('notConnectedUserBody')
    },
    connectedUserInfoFun(userItems){
      this.connectedUserDetails = userItems
      this.connectedUserDetailsPopup =  true
      $('body').addClass('notConnectedUserBody')
    },
    connectedUserInfoPopupClosedFun(){
      this.connectedUserDetails = ''
      this.connectedUserDetailsPopup =  false
      $('body').removeClass('notConnectedUserBody')
    },
    userCallConfirmationFun(userItems){
      this.callConfirmationUserDetails = userItems
      this.callConfirmationPopup =  true
      $('body').addClass('notConnectedUserBody')
    },
    userCallConfirmationClosedFun(){
      this.callConfirmationUserDetails = ''
      this.callConfirmationPopup =  false
      $('body').removeClass('notConnectedUserBody')
      this.calling_text = 'Yes, Call'
    },
   async showLoadMoreDataFun(url) {
      this.userLoading = true
     await axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextSteper = this.loadmoreData.data.next
          this.$set(this.memberAllUserResults, 'next', this.nextSteper)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.memberAllUserResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    chatRequestSend(items){
      this.notConnectedUserPopup = false
      this.checkDataTaskModal = true
      this.chatRequestDetails = items
    },
    closeChatRequestConfirm(){
      this.checkDataTaskModal = false,
      this.chatRequestDetails = '',
      this.message = ''
      $('body').removeClass('notConnectedUserBody')
    },
    sendChatRequestConfirm(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              from_user:this.userDetails.id,
              to_user:this.chatRequestDetails.id,
              message:this.message,
            }
            this.$store.dispatch('SendChatConnectionRequestFun', data)
              .then((res) => {
                  toast.success(res.data.user_msg || res.data.msg);
                  bus.$emit('sendRequestMessage', {
                    from_user: this.userDetails.id,
                    to_user: this.chatRequestDetails.id
                  });
                  this.checkDataTaskModal = false
                  this.chatRequestDetails = ''
                  this.message = ''
                  $('body').removeClass('notConnectedUserBody')
              }).catch((error) => {
                  toast.error(error.data.user_msg || error.data.msg);
                  this.checkDataTaskModal = false
                  this.chatRequestDetails = ''
                  this.message = ''
                  $('body').removeClass('notConnectedUserBody')
              })
            return;
        }
      });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://www.countryflags.io/${country.value}/shiny/64.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },

    // Video Call Request Function
    videoCallRequestFun(callerDetails){
      this.calling_text = 'Calling..'
      let callerFullName = this.userDetails.first_name + ' ' + this.userDetails.last_name
      videoSocketRef.emit({
        message: `${callerFullName} is calling you.`,
        type: "videoCalling",
        displayName: callerFullName,
        callerID: this.userDetails.id,
        targetId:callerDetails.id,
      });
      videoSocketRef.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      videoSocketRef.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      videoSocketRef.$on('videoCallAlertPopupClosed', this.notRecievedCall);
    },
    getAnswerOfVideoCall(getAnswerData){
        this.$router.push('/video/room/one-to-one-peer/#' + getAnswerData.videoCallRoomId)
    },
    getDeclinedOfVideoCall(declinedData){
      this.calling_text = 'Yes, Call'
    },
    notRecievedCall(notRecievedData){
      this.calling_text = 'Yes, Call'
    },
  },
  watch:{
    nextSteper(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
        // console.log("New Val:", new_val, "OLD VAL:", old_val )
      }
    },
    getmemberAllUserDetailsFun(){
      return  this.$store.getters.memberAllUsersGetters.data
    },
    SetIntialStatus() {
      if (this.memberAllUser != undefined) {
        // this.nextSteper = this.memberAllUser.next
        this.memberAllUserResults = this.memberAllUser.results
      }
    },
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    SetIntialSuperUserStatus(){
      if (this.userDetails != undefined) {
        this.is_superuser = this.userDetails.is_superuser
      }
      return
    }
  },
  beforeCreate: function() {
    // $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
    // $('body').removeClass('sidebar_collapsed')
    $('body').removeClass('notConnectedUserBody')
    next();
  },
}
